import { ACTIVITIES_TYPES_ASSO_REPORT } from '../../../../../constants';

// Which column each activity type is bucketed by, and whether that column holds a real
// timestamp ('instant') or a bare calendar date ('calendar'). Kept as data so the pairing
// is reviewable and testable in one place, rather than restated at six filterList() call
// sites where a mismatched pair is invisible.
//
// The kind cannot be inferred from the value: an 8-digit 20260830 may be a UTC day that
// needs converting or a day someone picked off a date picker, and guessing wrong shifts
// records a day (ENG-3537).
// Which value to read a new client's day from, and how to read it. created_dt is a real
// timestamp; created_date is a bare UTC day. The filter and the drill-down have to make the
// same choice or the table and the modal disagree by a day while the backend half of
// ENG-3537 is still rolling out and created_dt is absent.
export const newClientDate = item => {
  const hasTimestamp = item?.created_dt !== undefined && item?.created_dt !== null;
  return {
    value: hasTimestamp ? item.created_dt : item?.created_date,
    kind: hasTimestamp ? 'instant' : 'calendar',
  };
};

export const ASSOCIATE_REPORT_DATE_FIELDS = {
  // ai_activity_result.completion_date — 8-digit; see the caveat in utils/dateNumberToMoment
  [ACTIVITIES_TYPES_ASSO_REPORT.aiInsights]: { field: 'complete_date', kind: 'calendar' },
  // client_history.created_date — YYYYMMDDHHmmss
  [ACTIVITIES_TYPES_ASSO_REPORT.activities]: { field: 'created_date', kind: 'instant' },
  // total_outreach.dt — datetime
  [ACTIVITIES_TYPES_ASSO_REPORT.chatMessages]: { field: 'created_date', kind: 'instant' },
  // client.created_dt — datetime. Was client.created_date, an 8-digit UTC day that bucketed
  // evening additions to the previous day (ENG-3537).
  [ACTIVITIES_TYPES_ASSO_REPORT.newClients]: { field: 'created_dt', kind: 'instant' },
  // action.due_date — names a day; some rows carry a time, which is ignored
  [ACTIVITIES_TYPES_ASSO_REPORT.reminders]: { field: 'due_date', kind: 'calendar' },
  // sales_opp.created_date — YYYYMMDDHHmmss
  [ACTIVITIES_TYPES_ASSO_REPORT.salesOpps]: { field: 'created_date', kind: 'instant' },
  // client_appointment.created_dt — datetime
  [ACTIVITIES_TYPES_ASSO_REPORT.appointments]: { field: 'created_dt', kind: 'instant' },
};
